import React, {useState} from 'react';
import * as PropTypes from 'prop-types';

import Modal from '@lwt-helix/modal';
import { Button } from '@lwt-helix/buttons';

const LicenseModal = ({
                        show,
                        closeModal,
                        acceptLicence
                    }) => {
    const [isChecked, setIsChecked] = useState(false);

    const toggleUserSelected = () => {
        setIsChecked(!isChecked);
    };
    const resetSettings = () => {
        closeModal();
    };

    const handleSend = () => {
        return acceptLicence(isChecked);
    };

    const renderSendCancelButtons = (
        <>
            <Button
                outline={true}
                onClick={() => resetSettings()}
                className="mr-2"
                dataLwtId="cancel-invite-button"
            >
                Cancel
            </Button>
            <Button
                color={'primary'}
                onClick={() => handleSend()}
                dataLwtId="send-invite-button"
            >
                Accept
            </Button>
        </>
    );

    const renderModalButtons = () => {
        return renderSendCancelButtons;
    };

    const message = (
        <>
            <div>
                <p style={{fontSize: '1.15rem'}}>
                    You are leaving the Lone Wolf Back Office Platform. The services offered via Plaid, Inc. (“Plaid”) are provided by Plaid. You acknowledge and agree that Lone Wolf is not responsible for the Plaid service, and that Lone Wolf makes no representations or warranties regarding the Plaid service. You irrevocably waive any claim against Lone Wolf or any of its affiliates with respect to the Plaid service, or any combination of the Plaid service with services or software provided by Lone Wolf, and You represent that You have the authority to bind your organization to this disclaimer.
                </p>
                <br />
                <p style={{fontSize: '1.15rem'}}>
                    Lone Wolf will not be responsible or liable, directly or indirectly, for any actual or alleged damage or loss caused by or in connection with use of or reliance on the Plaid service even when used in connection with Lone Wolf Back Office.  If you decide to enable, access or use the Plaid service, be advised that your access and use of the Plaid service shall be governed solely by the terms and conditions of the agreement you enter into with Plaid.
                </p>
                <br />
                <p style={{fontWeight: 'bold', fontSize: '1.15rem'}}>
                    THE USE OF THE PLAID SERVICE IS DONE AT YOUR OWN DISCRETION AND RISK AND WITH YOUR AGREEMENT THAT LONE WOLF SHALL NOT BE RESPONSIBLE FOR ANY DAMAGE YOU EXPERIENCE AS A RESULT OF YOUR USE OF THE PLAID SERVICE. ANY WARRANTY THAT IS PROVIDED BY PLAID IS PROVIDED SOLELY BY PLAID, AND NOT BY LONE WOLF OR ANY LONE WOLF AFFILIATE.
                </p>
                <br />
                <div className={'text-left m-4'} style={{fontWeight: 'bold'}}>
                    <input type={'checkbox'} className={'form-check-input'}
                           onChange={() => toggleUserSelected()} />
                    <label className={'form-check-label'}  >
                        <span style={{fontSize: '1.15rem'}}>Don't show this again</span>
                    </label>
                </div>
            </div>
            <br />
            <div className="float-right">{renderModalButtons()}</div>
            <br />
        </>
    );

    return (
        <>
            <Modal
                size="xl"
                dataLwtId="license-agreement-modal"
                title="Third Party Service Agreement"
                show={show}
                showFooter={false}
            >
                {message}
            </Modal>
        </>
    );
};

LicenseModal.propTypes = {
    show: PropTypes.bool,
    closeModal: PropTypes.func,
    acceptLicence: PropTypes.func
};

export default LicenseModal;